import React from 'react';

export default function AlertError ({ msg }) {
    return (
        <div className="alert alert-danger show" role="alert">
            {msg}
        </div>
    );
}